/**
 * 전역 로깅 헬퍼 – success, info, warn, error, debug
 * 프로덕션에서는 level에 따라 필터링하거나 원격 전송 가능
 */

export type LogLevel = "debug" | "info" | "warn" | "error" | "success";

const PREFIX: Record<LogLevel, string> = {
  debug: "[DEBUG]",
  info: "[INFO]",
  warn: "[WARN]",
  error: "[ERROR]",
  success: "[OK]",
};

function log(level: LogLevel, message: string, ...args: unknown[]): void {
  const prefix = PREFIX[level];
  switch (level) {
    case "error":
      console.error(prefix, message, ...args);
      break;
    case "warn":
      console.warn(prefix, message, ...args);
      break;
    case "success":
      console.info(prefix, message, ...args);
      break;
    case "info":
    case "debug":
    default:
      console.log(prefix, message, ...args);
      break;
  }
}

export const Logger = {
  success(message: string, ...args: unknown[]): void {
    log("success", message, ...args);
  },
  info(message: string, ...args: unknown[]): void {
    log("info", message, ...args);
  },
  warn(message: string, ...args: unknown[]): void {
    log("warn", message, ...args);
  },
  error(message: string, ...args: unknown[]): void {
    log("error", message, ...args);
  },
  debug(message: string, ...args: unknown[]): void {
    log("debug", message, ...args);
  },
};
